import { useSelector } from "react-redux";

import { RootState } from "@/store/store";
import priceFormatter from "@/utils/priceFormatter";
import Title from "@/shared/components/Title/Title";

export default function ScheduleAppointmentServices() {
    const appointmentData = useSelector(
        (state: RootState) => state.appointments.existtAppointment,
    );
    const { services } = appointmentData;

    return (
        <div className='edit_drawer_container_services drawer_item'>
            <Title
                tag='h4'
                text={`Послуги (${services ? services.length : 0})`}
                style={{ marginBottom: 6 }}
            />
            <ul className='appointments_services_listing'>
                {services &&
                    services.map(item => (
                        <li className='shedule_service_item' key={item._id}>
                            <p className='service_item_title service_item'>
                                {item.title}
                            </p>
                            <p className='service_item_price service_item'>
                                {priceFormatter(item.price)}
                            </p>
                        </li>
                    ))}
            </ul>
        </div>
    );
}
